export const RotatingBadge = () => (
  <div className="pointer-events-none absolute bottom-28 right-10 z-10 hidden lg:block" aria-hidden="true" data-testid="hero-rotating-badge">
    <div className="relative h-32 w-32">
      <div className="animate-spin-slow absolute inset-0">
        <svg viewBox="0 0 100 100" className="h-full w-full">
          <defs>
            <path id="badgeCircle" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
          </defs>
          <text className="fill-[#F3E5AB]/80" style={{ fontSize: "7.6px", letterSpacing: "2.6px", fontFamily: "Montserrat, sans-serif" }}>
            <textPath href="#badgeCircle">ROYAL SKIN · DUBAI HEALTHCARE CITY · AESTHETICS ·</textPath>
          </text>
        </svg>
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <svg viewBox="0 0 24 24" className="h-6 w-6 fill-[#D4AF37]">
          <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z" />
        </svg>
      </div>
    </div>
  </div>
);
